import {Product} from "@/types/entities/product";
import {BaseActivityOccurrence} from "@/types/entities/activity/activityOccurrence";

export class BaseActivity {
  id?: string
  nameFr?: string
  nameEn?: string
  maxParticipants?: number
  isPublished?: boolean
}

export class TinyActivity extends BaseActivity {
  location?: string;
  activityOccurrences: BaseActivityOccurrence[] = [];
}

export class Activity extends Product {
  pageImage?: File
  savedPageImage?: string
  pageImageEn?: File
  savedPageImageEn?: string
  imageOverlayTextFr?: string
  imageOverlayTextEn?: string
  startsAt?: string;
  endsAt?: string;
  location?: string;
  locationAddress?: string;
  onlineUrl?: string;
  onlinePhoneNumber?: string;
  onlineWebinarNumber?: string;
  surveyUrl?: string;
  trainer?: string;
  trainerEmail?: string;
  maxParticipants?: number;
  isPrivate?: boolean;
  isPublished?: boolean;

  participantGuideUrl?: File;
  activityPresentationUrl?: File;
  activityRecordingUrl?: string;
}

export enum ActivityLocation {
  Online = "Online",
  OnSite = "OnSite",
}

export function getActivityLocations(): any {
  return [ActivityLocation.Online, ActivityLocation.OnSite];
}

export function getStartDate(activity: TinyActivity): string | undefined {
  return activity.activityOccurrences && activity.activityOccurrences.length > 0
      ? activity.activityOccurrences[0].startDate
      : undefined;
}

export function getEndDate(activity: TinyActivity): string | undefined {
  return activity.activityOccurrences && activity.activityOccurrences.length > 0
      ? activity.activityOccurrences[activity.activityOccurrences?.length-1].endDate
      : undefined;
}